/*** IMPORTS FROM imports-loader ***/
var $ = require("jquery");
var jQuery = require("jquery");

/**
 * Account page methods
 * -----------------------------------------------------------------------------
 *
 * @namespace accountMethods
 */

import password from 'password-strength-meter';
import axios from 'axios';

var accountMethods = {
  data: function data() {
    return {
      registerAccount: false,
      loginHelper: {
        state: null,
        message: null,
        customer: {},
        activation_url: null
      }
    };
  },

  methods: {
    _initAccount: function _initAccount() {
      if (app.currentTemplate !== 'account') {
        return;
      }

      var $accountTabs = $(app.selectors.accountTabs);
      var $loginForm = $(app.selectors.loginForm);
      var $recoverForm = $(app.selectors.recoverForm);
      var $passwordInput = $(app.selectors.passwordInput);
      var hash = window.location.hash;

      // account tabs => url hash
      hash && $accountTabs.find("ul.nav a[href=\"" + hash + "\"]").tab('show');

      $accountTabs.find('.nav a').click(function (e) {
        window.location.hash = $(this).attr('href');
      });

      function showRecoverPasswordForm() {
        $recoverForm.fadeIn();
        $loginForm.hide();
      }

      function hideRecoverPasswordForm() {
        $recoverForm.hide();
        $loginForm.fadeIn();
      }

      // allow deep linking to the recover password form
      if (hash === '#recover') {
        $accountTabs.find('ul.nav a[href="#login"]').tab('show');
        app.registerAccount = false;
        showRecoverPasswordForm();
      }

      if (hash === '#recoverForgate') {
        $accountTabs.find('ul.nav a[href="#login"]').tab('show');
        showRecoverPasswordForm();
        $('[data-register-link]').click();
      }

      $(document).on('click', '[data-register-link]', function () {
        $accountTabs.find('ul.nav a[href="#register"]').tab('show');
        app.registerAccount = true;
      });

      $(document).on('click', 'a[href="#login"]', function () {
        app.registerAccount = false;
      });

      $(document).on('click', '[data-recover-link]', function () {
        showRecoverPasswordForm();
      });

      $(document).on('click', '[data-cancel-recover-link]', function () {
        hideRecoverPasswordForm();
      });

      // password strength meter
      $passwordInput.password({
        shortPass: 'The password is too short',
        badPass: 'Weak; try combining letters & numbers',
        goodPass: 'Medium; try using special characters',
        strongPass: 'Strong password',
        containsUsername: 'The password contains the username',
        enterPass: 'Type your password',
        showPercent: false,
        showText: true, // shows the text tips
        animate: true, // whether or not to animate the progress bar on input blur/focus
        animateSpeed: 'fast', // the above animation speed
        username: false, // select the username field (selector or jQuery instance) for better password checks
        usernamePartialMatch: false, // whether to check for username partials
        minimumLength: 6 // minimum password length (below this threshold, the score is 0)
      });

      // toggle collapse for edit address
      // show one card at a time
      $(document).on('click', '[data-edit-address]', function () {
        var target = $(this).data('target');
        $('.collapse').collapse('hide');
        $(target).collapse('show');

        $('html').animate({
          scrollTop: $(target).offset().top
        }, 400);

        // unlock window - fix scrolltop common problem
        $(window).bind('mousewheel', function () {
          $('html').stop();
        });
      });

      app._initShopifyAccountMethods();

      $(".modal-description").on("click", function () {
        $(".modal.modal-pop").addClass("active");
      });

      $("#difficult_popup .close").on("click", function () {
        $(".modal.modal-pop").removeClass("active");
      });
    },
    _submitLoginForm: function _submitLoginForm() {
      var formEl = $('#customer_login')[0];
      var formData = new FormData();
      formData.append('email', $('[name="customer[email]"]').val());
      var customerEmail = $('[name="customer[email]"]').val();
      var customerPassword = $('[name="customer[password]"]').val();

      if (customerPassword && customerEmail) {
        formEl.submit();
      } else {
        if (!customerEmail) {
          $('#customerEmail').addClass('is-invalid');
          return;
        }

        $('#customerEmail').removeClass('is-invalid');

        app.isLoading = true;
        // const customerData = await axios.get(`/apps/store-utilities-proxy/getCustomerData?customer_email=${customerEmail}`);
        axios({
          method: 'post',
          url: 'https://scripts.doggielawn.com/Doggielawn/get_customer_detail.php',
          data: formData,
          headers: { 'Content-Type': 'multipart/form-data' }
        })
        // eslint-disable-next-line promise/always-return
        .then(function (response) {
          // handle success
          app.loginHelper.message = response.data.message;
          if (response.data.status == 1) {
            app.loginHelper.customer = response.data.data;

            if (app.loginHelper.customer.state == 'disabled' || app.loginHelper.customer.state == 'invited') {
              var disData = new FormData();
              disData.append('customer_id', app.loginHelper.customer.id);
              axios({
                method: 'post',
                url: 'https://scripts.doggielawn.com/Doggielawn/activate_shopify_customer.php',
                data: disData,
                headers: { 'Content-Type': 'multipart/form-data' }
              })
              // eslint-disable-next-line promise/always-return
              .then(function (response) {
                // handle success
                app.loginHelper.activation_url = response.data.data.account_activation_url;
                app.loginHelper.state = app.loginHelper.customer.state;
                app.isLoading = false;
              }).catch(function (response) {
                // handle error
                app.isLoading = false;
              });
            } else {
              app.loginHelper.state = app.loginHelper.customer.state;
            }
          } else {
            app.loginHelper.state = 'unregistered';
          }
          app.isLoading = false;
        }).catch(function (response) {
          // handle error
          app.isLoading = false;
        });

        if (customerPassword) {
          formEl.submit();
        } else {
          $('#customerPassword').addClass('is-invalid');
        }
      }
    },
    _initShopifyAccountMethods: function _initShopifyAccountMethods() {
      if ($('[data-account-address]').length === 0) {
        return;
      }

      var customCheck = document.querySelector('#address_default_address_new');
      $("input[name*='address[default]']").addClass('custom-control-input');
      if (customCheck.classList) {
        customCheck.classList.add('custom-control-input');
      }

      Shopify.CustomerAddress = {
        destroy: function destroy(id, confirm_msg) {
          if (confirm(confirm_msg || 'Are you sure you wish to delete this address?')) {
            Shopify.postLink("/account/addresses/" + id, {
              parameters: { _method: 'delete' }
            });
          }
        }
      };
    }
  }
};

export default accountMethods;